module.exports = __webpack_public_path__ + "media/newstyle/images/img-footer-bok2-5bb0508c9d92d0aad022a065085484e8.svg";